import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 3px 0 0 0;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 5px;
  border-top: 1px solid grey;
  cursor: pointer;

  >div:first-child {
    display: flex;
    align-items: center;
    margin-right: 5px;
    height: 18px;
    width: 18px;
}`;

export const UnassignWrapper = styled(ActionWrapper)(props => {
  if (props.hasOnlyResult) {
    return `
      cursor: not-allowed;
      color: #d4d4d4;

      &:hover {
        cursor: not-allowed;
        color: #d4d4d4;
      }

      >div {
        color: #d4d4d4;
      }
    `;
  }
  return null;
});

export const Heading = styled.div`
  padding: 2px 6px;
  font-weight: 800;
  color: black;
`;

export const SubHeading = styled.div`
  color: black;
  padding: 2px 6px;
  font-weight: 100;
  font-size: 11px;
`;

export const AttemptsText = styled.div`
  color: black;
  padding: 2px 6px;
  font-weight: 600;
  font-size: 11px;
`

export const Attempts = styled.div`
  display: flex;
  padding: 5px 6px 10px 6px;
`



// WEBPACK FOOTER //
// ./components/status-cell/contextual-menu/styled.js